import { authApiCall } from '../auth/saga';


export const getBusinessProductsApi = () =>
  authApiCall({
    url: '/product/list-business-products/',
    method: 'get',
  });

export const productsPayByPointsApi = (payload) =>
  authApiCall({
    url: '/product/pay-by-points/',
    method: 'post',
    data: payload,
  });

